<template>
    <div v-if="course && $user.isModerator" id="course_status_message">
        <div v-if="course.is_planned && course.details_visible" :class="custom_class" class="tw-fixed tw-m-4 tw-rounded tw-bg-blue-600 tw-text-white tw-font-semibold tw-px-4 tw-py-3 tw-shadow tw-pointer-events-none tw-text-xs tw-text-center" style="width: 222px;">
            <i class="fa fa-calendar tw-pr-1"></i>
            {{ $t('membership.product_planned_with_details_visible') }}
        </div>

        <div v-else-if="course.is_planned" :class="custom_class" class="tw-fixed tw-m-4 tw-rounded tw-bg-blue-600 tw-text-white tw-font-semibold tw-px-4 tw-py-3 tw-shadow tw-pointer-events-none tw-text-xs tw-text-center" style="width: 222px;">
            <i class="fa fa-calendar tw-pr-1"></i>
            {{ $t('membership.product_planned') }}
        </div>

        <div v-else-if="course.is_draft" :class="custom_class" class="tw-fixed tw-m-4 tw-rounded tw-bg-orange-600 tw-text-white tw-font-semibold tw-px-4 tw-py-3 tw-shadow tw-pointer-events-none tw-text-xs tw-text-center" style="width: 222px;">
            <i class="fa fa-lock tw-pr-1"></i>
            {{ $t('membership.product_in_draft') }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CourseStatusMessage.vue',

        props: {
            course: {
                required: true,
            },

            custom_class: {
                required: false,
                type: String
            }
        }
    };
</script>
